import styled from 'styled-components';
import { Row } from 'tno-core';

export const FilterContentSection = styled(Row)`
  .time-offset-filter,
  .content-owner-filter {
    margin-bottom: 0.25em;
  }
`;
